const TONES = {
  ok: "text-ok border-ok/30 bg-ok/10",
  warn: "text-warn border-warn/30 bg-warn/10",
  err: "text-err border-err/30 bg-err/10",
  neutral: "text-ink-dim border-border bg-surface",
  info: "text-brand border-brand/30 bg-brand/10",
};

export default function StatusChip({ tone = "neutral", children, dot = false, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded border ${TONES[tone]} ${className}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${tone === "ok" ? "bg-ok animate-pulse" : tone === "warn" ? "bg-warn" : tone === "err" ? "bg-err" : "bg-ink-dim"}`} />}
      {children}
    </span>
  );
}
